    $(document).ready(function () {
        var url = window.location.href;
        var tab = url.split('#');
        if (tab.length > 1) {
            var tabName = tab[1];
            if (tabName == "store") {
                $('a[href="#store"]').click();
            }
            else {
                $('a[href="#private"]').click();
            }
        }
        else {
             var isStore = pzSignUp.v0 == pzSignUp.v1;

        if (isStore) {
            $('#content-for-private').html('');
            console.log("isStore");
        }
        else {
            console.log("isPrivate");
        }
        }

    })

    $(document).on('select-change', '#store-category-select', function () {
        var selected = document.querySelector('#store-category .option-item.selected');
        $('#CategoryId').val(selected ? selected.getAttribute('data-id') : '');
    });

    function setPrivateTypeAccount() {
        $('.typeAccount').val(pzSignUp.v2);

        $('#content-for-private').html(document.getElementById('data-for-private').innerHTML);

        $('.nav-tabs .nav-link').removeClass('active');
        $('.nav-tabs a[href="#private"]').addClass('active');

        $('#private').addClass('active').removeClass('fade');
        $('#store').addClass('fade').removeClass('active');

        history.replaceState(null, '', '#private');
    }

    function setStoreTypeAccount() {
        $('.typeAccount').val(pzSignUp.v1);

        $('#content-for-private').html('');

        $('.nav-tabs .nav-link').removeClass('active');
        $('.nav-tabs a[href="#store"]').addClass('active');

        $('#store').addClass('active').removeClass('fade');
        $('#private').addClass('fade').removeClass('active');

        history.replaceState(null, '', '#store');
    }
